export default class Record {
  constructor(data, recordIndex){
    this.boardConfig = data.boardConfig
    this.robotPositions = data.robotPositions
    this.solution = data.solution
    this.goal = data.goal
    this.goalColor = data.goalColor
    this.recordIndex = recordIndex
  }

  modifyRecord(data){
    for(var key in data){
      this[key] = data[key]
    }
  }
}


// WEBPACK FOOTER //
// ./game/Record.js